angular
  .module('resyApp')
  .component('resyResetPasswordContainer', {
    template: `
      <resy-password-reset context="'resy.com'"></resy-password-reset>
      <resy-download></resy-download>
    `,
  });

export default () => {};
